import { API_BASE_URL } from "./client";

const requestPresignedUpload = async ({ productId, fileName, contentType }) => {
  console.info("[assets.requestPresignedUpload] Requesting presigned upload", {
    productId,
    fileName,
    contentType,
  });
  const response = await fetch(`${API_BASE_URL}/api/assets/presign-upload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ productId, fileName, contentType }),
  });

  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch (_err) {
    data = text;
  }

  if (!response.ok) {
    const error = new Error(data?.message || "Unable to request upload URL.");
    error.status = response.status;
    error.data = data;
    throw error;
  }

  try {
    const signedUrl = new URL(data?.uploadUrl || "");
    const checksumParams = Array.from(signedUrl.searchParams.keys()).filter(
      (param) => param.startsWith("x-amz-sdk-checksum") || param.startsWith("x-amz-checksum")
    );
    console.info("[assets.requestPresignedUpload] Received presigned upload", {
      key: data?.key,
      hasChecksumParams: checksumParams.length > 0,
      checksumParams,
    });
  } catch (_err) {
    console.info("[assets.requestPresignedUpload] Received presigned upload", { key: data?.key });
  }

  return data;
};

const uploadToPresignedUrl = async ({ uploadUrl, file, contentType }) => {
  const headers = {
    "Content-Type": contentType,
  };
  try {
    const signedUrl = new URL(uploadUrl || "");
    const checksumParams = Array.from(signedUrl.searchParams.keys()).filter(
      (param) => param.startsWith("x-amz-sdk-checksum") || param.startsWith("x-amz-checksum")
    );
    console.info("[assets.uploadToPresignedUrl] Uploading via PUT", {
      fileName: file?.name,
      fileType: file?.type,
      fileSize: file?.size,
      contentType,
      headers,
      hasChecksumParams: checksumParams.length > 0,
      checksumParams,
    });
  } catch (_err) {
    console.info("[assets.uploadToPresignedUrl] Uploading via PUT", {
      fileName: file?.name,
      fileType: file?.type,
      fileSize: file?.size,
      contentType,
      headers,
    });
  }
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers,
    body: file,
  });

  if (!response.ok) {
    const error = new Error("Unable to upload image to storage.");
    error.status = response.status;
    throw error;
  }

  return true;
};

const requestPresignedDownload = async (keys = []) => {
  const list = Array.isArray(keys) ? keys.filter(Boolean) : keys ? [keys] : [];
  if (!list.length) return { urls: {} };

  const response = await fetch(`${API_BASE_URL}/api/assets/presign-download`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ keys: list }),
  });

  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch (_err) {
    data = text;
  }

  if (!response.ok) {
    const error = new Error(data?.message || "Unable to request download URL.");
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

export { requestPresignedUpload, uploadToPresignedUrl, requestPresignedDownload };
